<template>
  <div class="item" @click="goDetail(item.id)">
    <div class="item-time">
      <p class="day">{{ item.pub_time | GetDay }}</p>
      <p class="month">{{ item.pub_time | GetYearMonth }}</p>
    </div>
    <div class="item-txt " :style="{ maxWidth: (item.cover_img ? 'calc(100% - 210px - 140px)' : '') }">
      <h3 class="item-title" :title="item.title">{{ item.title }}</h3>
      <div class="item-sub" v-if="item.introduce">
        <p>{{ item.introduce }}</p>
      </div>
      <div class=" default2-btn item-btn">查看详情</div>
    </div>
    <div class="item-img" v-if="item.cover_img">
      <img :src="item.cover_img" alt="" @error="imgError(item)">
    </div>
  </div>
</template>

<script>
export default {
  name: 'newsItem',
  props: {
    item: Object,
    newWindow: Boolean
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    //进入详情页
    goDetail(id) {
      try {
        if (this.$route.meta.detailPage && !this.newWindow) {
          this.$router.push({
            path: '/news/' + id,
            params: {
              id: id
            }
          })
          return
        }
        let link = this.$router.resolve({
          path: '/news/' + id,
          params: {
            id: id
          }
        })
        window.open(link.href, '_blank')
      } catch (err) {
        this.$router.push({
          path: '/news/' + id,
          params: {
            id: id
          }
        })
      }

    },
  },
}
</script>
<style scoped ></style>